import React from 'react'
import HtnLogger from './Logger/HtnLogger'


function PiePrincipal(){
    return (
        <div className="navbar navbar-default yamm navbar-fixed-bottom ">
          <div className="container">                                    
              <HtnLogger></HtnLogger>              
          </div>
      </div>
        
    )
}

export default PiePrincipal